<!-- Color Strip -->
<div class="color-strip">
    <div class="fred"></div>
    <div class="forange"></div>
    <div class="fblue"></div>
</div>
<nav class="navbar navbar-dark navbar-expand-lg">
    <div class="container-fluid" style="max-width: 1170px;">
        <a class="navbar-brand">
            <a href="/"><img src="https://frc-cdn.firstinspires.org/eventweb_frc/ProgramLogos/FRC_Horz_RGB_rev_sm.png" style="max-width: 169px;"/></a>
            <span class="d-none d-md-inline-block">&nbsp;&nbsp;</span>
            <strong class="d-none d-md-inline-block">{{title}}</strong>
        </a>
        <!--<button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div id="navbarSupportedContent" class="collapse navbar-collapse">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" href="#">
                        <span>2024 Season Info</span>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-start">
                        <li>
                            <a class="dropdown-item" href="/2024/Events/EventList">
                                <i class="fas fa-fw fa-calendar-alt"></i> Events
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="/2024/awards">
                                <i class="fas fa-fw fa-award"></i> Awards
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="/2024/districts">
                                <i class="fas fa-fw fa-globe-americas"></i> Districts
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" href="/2024/allteams">
                                <i class="fas fa-fw fa-users"></i> Teams
                            </a>
                        </li>
                    </ul>
                </li>



            </ul>
            <form class="d-flex" action="/search">
                <input type="hidden" name="season" value="2024" />
                <input type="search" class="form-control me-2" name="jump" autocomplete="off" placeholder="Team # / Event Code" width="12" maxlength="20" required>
                <button type="submit" class="btn btn-outline-light">Search</button>
            </form>
        </div>-->
    </div>
</nav>

<div class="container" style="max-width: 1170px; padding-left: 0; padding-right: 0; box-shadow: -12px -16px 28px 0 rgba(0,0,0,0.6),12px -16px 28px 0 rgba(0,0,0,0.6);">
<router-outlet></router-outlet>
</div>
<div class="container-fluid footer-box" style="background-color: #231F20;">
    <footer class="footer container py-3 footer-text" style="max-width: 1170px;">
        <div class="row text-center">
            <div class="col-md-4">
                <img id="firstLogoFooter" ngSrc="eventweb_common/FIRST_Horz_OneColor_reverse.png" width=350 height=92 priority />
                <br />
                <nav class="nav justify-content-center">
                    <a class="nav-link text-light" href="https://www.facebook.com/FIRSTOfficial"><i class="fab fa-facebook-f fa-lg"></i></a>
                    <a class="nav-link text-light" href="https://www.youtube.com/user/FIRSTWorldTube"><i class="fab fa-youtube fa-lg"></i></a>
                    <a class="nav-link text-light" href="https://instagram.com/first_official_"><i class="fab fa-instagram fa-lg"></i></a>
                    <a class="nav-link text-light" href="https://www.twitter.com/firstweets"><i class="fab fa-twitter fa-lg"></i></a>
                    <a class="nav-link text-light" href="https://www.pinterest.com/firstinspires"><i class="fab fa-pinterest-p fa-lg"></i></a>
                    <a class="nav-link text-light" href="https://www.linkedin.com/company/first_2"><i class="fab fa-linkedin-in fa-lg"></i></a>
                    <a class="nav-link text-light" href="https://www.twitch.tv/firstinspires"><i class="fab fa-twitch fa-lg"></i></a>
                </nav>
            </div>
            <div class="col-md-8">
                <div class="row text-center">
                    <div class="col-md-4 col-sm-6">
                        <nav class="nav flex-column">
                            <a href="https://frc-events.firstinspires.org/services" class="nav-link footer-links" title="APIServices" target="_blank">API/SERVICES</a>
                            <a href="https://www.firstinspires.org/about/vision-and-mission" class="nav-link footer-links" title="About" target="_blank">ABOUT</a>
                            <a href="https://www.firstinspires.org/about/contact-us" class="nav-link footer-links" title="Contact" target="_blank">CONTACT US</a>

                        </nav>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <nav class="nav flex-column">
                            <a href="https://www.firstinspires.org/donate?utm_source=frc-events&utm_medium=footer&utm_campaign=donation" class="nav-link footer-links" title="Donate" target="_blank">DONATE</a>
                            <a href="https://www.brandedstore.com/First/shop.axd/ViewBrand" class="nav-link footer-links" title="Privacy" target="_blank"><em>FIRST</em> STORE</a>
                        </nav>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <nav class="nav flex-column">
                            <a href="https://www.firstinspires.org/about/privacy-policy" class="nav-link footer-links" title="Privacy" target="_blank">PRIVACY POLICY</a>
                            <a href="https://www.firstinspires.org/about/legal-notices" class="nav-link footer-links" title="" target="_blank">LEGAL NOTICES</a>
                        </nav>
                    </div>
                </div>
                <br />
                <div class="row text-center fs-6">
                    <p class="text-muted">Copyright &copy; 2025 For Inspiration and Recognition of Science and Technology (<em>FIRST</em>)</p>
                </div>
            </div>
        </div>
    </footer>
</div>